import { camelCase } from 'lodash-es';
import { apartmentConstants } from '@/modules/Housing/lib';

const {
  UNIT_ID_LABEL,
  UNIT_REP_TYPE_LABEL,
  UNIT_APARTMENT_TYPE_LABEL,
  UNIT_HAS_COUCH_LABEL,
  UNIT_STREET_ADDRESS_LABEL,
  UNIT_NOTES_LABEL,
  UNIT_NUMBER_OF_ROOMS_LABEL,
  UNIT_ROOMS_LABEL,
  FURNITURE_FURNISHED_LABEL,
  FURNITURE_MONTHLY_COST_LABEL,
  FURNITURE_DELIVERY_DATE_LABEL,
  FURNITURE_PICKUP_DATE_LABEL,
  FURNITURE_WASHER_DRYER_DELIVERY_DATE_LABEL,
  FURNITURE_WASHER_DRYER_PICKUP_DATE_LABEL,
  FURNITURE_EMAIL_LABEL,
  FURNITURE_PHONE_LABEL,
  FURNITURE_NOTES_LABEL,
  UTILITIES_IS_ADDED_TO_REP_LABEL,
  UTILITIES_ELECTRIC_ACCOUNT_NUMBER_LABEL,
  UTILITIES_GAS_ACCOUNT_NUMBER_LABEL,
  UTILITIES_NOTES_LABEL,
  LEASED_BY_LABEL,
  EXPECTED_RENT_DUE_LABEL,
  RENT_DUE_DATE_LABEL,
  EXPECTED_RENT_LABEL,
  EXPECTED_START_DATE_LABEL,
  EXPECTED_END_DATE_LABEL,
  ACTUAL_START_DATE_LABEL,
  ACTUAL_END_DATE_LABEL,
  LEASED_NOTES_LABEL,
  MOVE_OUT_NOTICE_DATE_LABEL,
  MOVE_OUT_NOTICE_GIVEN_LABEL,
  DATE_MOVE_OUT_NOTICE_WAS_GIVEN_LABEL,
  ACTUAL_MOVE_OUT_DATE_LABEL,
  MOVE_OUT_NOTES_LABEL,
  UNIT_NUMBER_OF_BEDS_LABEL,
} = apartmentConstants;

const fieldLabels = {
  unit_id: UNIT_ID_LABEL,
  rep_type: UNIT_REP_TYPE_LABEL,
  apartment_type: UNIT_APARTMENT_TYPE_LABEL,
  has_couch: UNIT_HAS_COUCH_LABEL,
  street_address: UNIT_STREET_ADDRESS_LABEL,
  unit_notes: UNIT_NOTES_LABEL,
  number_of_rooms: UNIT_NUMBER_OF_ROOMS_LABEL,
  rooms: UNIT_ROOMS_LABEL,
  furnished: FURNITURE_FURNISHED_LABEL,
  furniture_monthly_cost: FURNITURE_MONTHLY_COST_LABEL,
  furniture_delivery_date: FURNITURE_DELIVERY_DATE_LABEL,
  furniture_pickup_date: FURNITURE_PICKUP_DATE_LABEL,
  washer_dryer_delivery_date: FURNITURE_WASHER_DRYER_DELIVERY_DATE_LABEL,
  washer_dryer_pickup_date: FURNITURE_WASHER_DRYER_PICKUP_DATE_LABEL,
  furniture_company_email: FURNITURE_EMAIL_LABEL,
  furniture_company_phone_number: FURNITURE_PHONE_LABEL,
  furniture_notes: FURNITURE_NOTES_LABEL,
  is_utilities_added_to_rep: UTILITIES_IS_ADDED_TO_REP_LABEL,
  electric_account_number: UTILITIES_ELECTRIC_ACCOUNT_NUMBER_LABEL,
  gas_account_number: UTILITIES_GAS_ACCOUNT_NUMBER_LABEL,
  utilities_notes: UTILITIES_NOTES_LABEL,
  leased_by: LEASED_BY_LABEL,
  expected_rend_due: EXPECTED_RENT_DUE_LABEL,
  rent_due_date: RENT_DUE_DATE_LABEL,
  expected_rend: EXPECTED_RENT_LABEL,
  expected_start_date: EXPECTED_START_DATE_LABEL,
  expected_end_date: EXPECTED_END_DATE_LABEL,
  actual_start_date: ACTUAL_START_DATE_LABEL,
  actual_end_date: ACTUAL_END_DATE_LABEL,
  lease_details_notes: LEASED_NOTES_LABEL,
  move_out_notice_date: MOVE_OUT_NOTICE_DATE_LABEL,
  move_out_notice_given: MOVE_OUT_NOTICE_GIVEN_LABEL,
  date_move_out_notice_was_given: DATE_MOVE_OUT_NOTICE_WAS_GIVEN_LABEL,
  actual_move_out_date: ACTUAL_MOVE_OUT_DATE_LABEL,
  move_out_notes: MOVE_OUT_NOTES_LABEL,
  number_of_beds: UNIT_NUMBER_OF_BEDS_LABEL,
};

const handleHistoryLabel = (key) => fieldLabels[key] ?? camelCase(key);

export default handleHistoryLabel;
